angular.module 'zc.core'
# These values also exist in app/src/utils/currencies.js
# The fractionSize also related to convertCurrencyForExactPrecision function in peronyan_cool/src/lib.coffee
.constant 'currencies',
  jpy:
    symbol: ''
    fractionSize: 0
    suffix: '円'
  usd:
    symbol: ''
    fractionSize: 2
    suffix: 'USD'
  aud:
    symbol: ''
    fractionSize: 2
    suffix: 'AUD'
  cad:
    symbol: 'C$'
    fractionSize: 2
    suffix: ''
  chf:
    symbol: 'CHF'
    fractionSize: 2
    suffix: ''
  cny:
    symbol: ''
    fractionSize: 2
    suffix: 'Yuan'
  eur:
    symbol: '€'
    fractionSize: 2
    suffix: ''
  gbp:
    symbol: '£'
    fractionSize: 2
    suffix: ''
  hkd:
    symbol: ''
    fractionSize: 2
    suffix: 'HKD'
  idr:
    symbol: 'Rp'
    fractionSize: 0
    suffix: ''
  inr:
    symbol: '₹'
    fractionSize: 0
    suffix: ''
  krw:
    symbol: '₩'
    fractionSize: 0
    suffix: ''
  myr:
    symbol: 'RM'
    fractionSize: 2
    suffix: ''
  nzd:
    symbol: 'NZ$'
    fractionSize: 2
    suffix: ''
  php:
    symbol: '₱'
    fractionSize: 2
    suffix: ''
  sgd:
    symbol: ''
    fractionSize: 2
    suffix: 'SGD'
  sek:
    symbol: ''
    fractionSize: 0
    suffix: 'kr'
  thb:
    symbol: '฿'
    fractionSize: 2
    suffix: ''
  twd:
    symbol: 'NT$'
    fractionSize: 0
    suffix: ''
  vnd:
    symbol: ''
    fractionSize: 0
    suffix: '₫'
  zar:
    symbol: 'R'
    fractionSize: 2
    suffix: ''
  clp:
    symbol: '$'
    fractionSize: 2
    suffix: ''
  cop:
    symbol: '$'
    fractionSize: 2
    suffix: ''



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/constants/currencies.coffee